// src/utils/getEffectivePlanByProfile.js
/**
 * Returns the effective plan for a user profile.
 * - Uses public.profiles.plan by default
 * - If beta_plan is set and beta_status !== 'ended', beta_plan overrides plan
 * - Always returns a lowercase string (fallback: 'standard')
 */
export default function getEffectivePlanByProfile(profile) {
  const basePlan = String(profile?.plan || "standard").trim().toLowerCase();
  const betaPlan = String(profile?.beta_plan || "").trim().toLowerCase();
  const betaStatus = String(profile?.beta_status || "").trim().toLowerCase();

  if (betaPlan && betaStatus && betaStatus !== "ended") return betaPlan;
  return basePlan || "standard";
}
